import type { ReactNode } from 'react'

import type { MessageKey } from '@/lib/i18n/messages/en'
import { useT } from '@/lib/i18n/translate'

/** The guide's building blocks; the content files hold only text. */

export function H2({ children }: { children: ReactNode }) {
  return <h2 className="mt-6 text-lg font-semibold first:mt-0">{children}</h2>
}

export function P({ children }: { children: ReactNode }) {
  return <p className="leading-relaxed">{children}</p>
}

export function Ul({ children }: { children: ReactNode }) {
  return <ul className="flex list-disc flex-col gap-1.5 pl-5 leading-relaxed">{children}</ul>
}

export function Note({ children }: { children: ReactNode }) {
  return <p className="border-accent bg-accent-soft rounded-lg border-l-4 px-3 py-2 leading-relaxed">{children}</p>
}

/** A UI label quoted from the dictionary, so a rename reaches the guide by itself. */
export function L({ k }: { k: MessageKey }) {
  const t = useT()
  return <strong className="font-medium">“{t(k)}”</strong>
}
